export const kvSlideshow = () => {
    const MOBILE_BP = 768;
    const SLIDE_DURATION = 5000;
    const FADE_IN_DELAY = 5000; // Must match CSS: animationCont fadeIn delay (5s)

    let figures = [];
    let currentIndex = 0;
    let intervalId = null;

    const isMobile = () => window.innerWidth <= MOBILE_BP;

    const getAllFigures = () => {
        const cont = document.querySelector('.kvSec__animationCont');
        if (!cont) return [];
        return Array.from(cont.querySelectorAll('.kvSec__figure'));
    };

    const showSlide = (index) => {
        figures.forEach((fig, i) => {
            if (i === index) {
                fig.classList.add('is-active');
            } else {
                fig.classList.remove('is-active');
            }
        });
    };

    const nextSlide = () => {
        currentIndex = (currentIndex + 1) % figures.length;
        showSlide(currentIndex);
    };

    const startSlideshow = () => {
        if (intervalId) return;
        figures = getAllFigures();
        if (figures.length === 0) return;

        currentIndex = 0;
        showSlide(0);
        intervalId = setInterval(nextSlide, SLIDE_DURATION);
    };

    const stopSlideshow = () => {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
        figures.forEach(fig => fig.classList.remove('is-active'));
    };

    const handleResize = () => {
        if (isMobile()) {
            if (!intervalId) startSlideshow();
        } else {
            stopSlideshow();
        }
    };

    if (!isMobile()) return;

    figures = getAllFigures();
    if (figures.length === 0) return;

    // Wait for the container fadeIn animation, then start
    setTimeout(() => {
        startSlideshow();
    }, FADE_IN_DELAY);

    window.addEventListener('resize', handleResize);
};
